import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { ValidationFormSchemaValues } from 'src/features/validations/utils/formSchema';
import { validationMessages } from 'src/features/validations/utils/messages';
import { ValidationType } from 'src/features/validationTypes/utils/types';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form, FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'src/registry/ui/Select';
import React from 'react';

type ValidationFormProps = {
    form: UseFormReturn<ValidationFormSchemaValues>;
    onSubmit: (values: ValidationFormSchemaValues) => void;
    types?: ListResponseSmartParkAPI<ValidationType>;
    setValidatorAccountFromSelectedType: React.Dispatch<React.SetStateAction<string>>;
};

export default function ValidationForm({
    onSubmit,
    form,
    types,
    setValidatorAccountFromSelectedType,
}: ValidationFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<ValidationFormSchemaValues>
                disabled
                form={form}
                name="visitor"
                label={formatMessage(validationMessages.visitor)}
            />
            <FormField
                control={form.control}
                name="type"
                render={({ field }) => {
                    return (
                        <FormItem variant="dialog">
                            <FormLabel variant="dialog" required>
                                {formatMessage(validationMessages.type)}
                            </FormLabel>
                            <FormControlStack>
                                <FormControl>
                                    <Select
                                        onValueChange={(value) => {
                                            field.onChange(value);

                                            const selectedType = types?.results?.find(
                                                (option) => option.id.toString() === value,
                                            );

                                            setValidatorAccountFromSelectedType(selectedType?.validator_account ?? '');
                                        }}
                                        value={field.value?.toString()}
                                    >
                                        <SelectTrigger className="w-full">
                                            <SelectValue placeholder={`${formatMessage(validationMessages.type)}...`} />
                                        </SelectTrigger>
                                        <SelectContent>
                                            {types?.results?.map((option) => (
                                                <SelectItem key={option.id} value={option.id}>
                                                    {option.name}
                                                </SelectItem>
                                            ))}
                                        </SelectContent>
                                    </Select>
                                </FormControl>
                                <FormMessage />
                            </FormControlStack>
                        </FormItem>
                    );
                }}
            />
        </Form>
    );
}
